import ActionNodeTemplate from "../templates/ActionNodeTemplate";
import { Tooltip, Typography } from "@mui/material";
import { normalizeLeadAgeRestriction } from "../../../../utils/workflow/leadAgeRestriction";

const formatPipeConditions = (data) => {
  const pipeData =
    data.pipeConditions ||
    data.pipes ||
    data.queryConditions ||
    data.conditions;

  if (!Array.isArray(pipeData) || pipeData.length === 0) {
    return "No query conditions set";
  }

  const andConditions = pipeData.filter((c) => c.logicalOperator === "AND");
  const orConditions = pipeData.filter((c) => c.logicalOperator === "OR");

  const formatCondition = (condition) => {
    if (!condition.table || !condition.field || !condition.operator) return "";

    const op = String(condition.operator).toLowerCase();
    let val = condition.value;

    if (
      typeof val === "string" &&
      op.includes("between") &&
      val.includes("|")
    ) {
      const [a = "", b = ""] = val.split("|");
      val = `${a} - ${b}`;
    }

    return `${condition.table}.${condition.field} ${condition.operator} ${val}`;
  };

  let result = "";
  if (andConditions.length > 0) {
    result += andConditions.map(formatCondition).filter(Boolean).join(" AND ");
  }
  if (orConditions.length > 0) {
    if (result) result += " OR ";
    result += orConditions.map(formatCondition).filter(Boolean).join(" OR ");
  }

  return result || "Query conditions configured";
};

export default function SQLQueryActionNode({ id, type, data, selected }) {
  const conditionsText = formatPipeConditions(data);
  const batchSize = data.batchSizePerRun;
  const leadAgeRestriction = normalizeLeadAgeRestriction(data.leadAgeRestriction);

  return (
    <ActionNodeTemplate id={id} type={type} data={data} selected={selected}>
      <Tooltip title={conditionsText} placement="top">
        <Typography noWrap fontSize={8}>
          {conditionsText}
        </Typography>
      </Tooltip>
      {batchSize ? (
        <Tooltip title={`Batch: ${batchSize} per run`} placement="top">
          <Typography noWrap fontSize={8}>
            Batch: {batchSize}/run
          </Typography>
        </Tooltip>
      ) : null}
      {leadAgeRestriction.enabled ? (
        <Tooltip
          title={`Lead age filter: exclude leads from last ${leadAgeRestriction.minDays} days`}
          placement="top"
        >
          <Typography noWrap fontSize={8}>
            Lead age: {leadAgeRestriction.minDays}d+
          </Typography>
        </Tooltip>
      ) : null}
    </ActionNodeTemplate>
  );
}
